import { useCallback, useEffect, useState } from "react";
import useFetch from "../../hooks/useFetch";
import Cookies from "js-cookie";
import { UsuallyResponse } from "../../types";

type CompetenceData = {
  result: boolean;
};

const useKolActivityCheck = (baseUrl: string) => {
  const { get } = useFetch(baseUrl);

  const [hasCompetence, setHasCompetence] = useState(false);
  const [mounted, setMounted] = useState(false);
  const [hasValidated, setHasValidated] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const isDemoTrading = Cookies.get("Global-UserViewType") === "demo-trading";
  const currentPathName = mounted && typeof window !== "undefined" ? window.location.pathname : "";

  const getIfHasCompetence = useCallback(async () => {
    setIsLoading(true);
    try {
      const activityId = process.env.BUILD_MODE === "production" ? "999" : "717";
      const result = await get<UsuallyResponse<CompetenceData>>(
        `uapi/v1/activity_center/kol_activity/check?activity_id=${activityId}`
      );
      if (result.code === 200) {
        setHasCompetence(result.data.result);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setHasValidated(true);
      setIsLoading(false);
    }
  }, [get]);

  useEffect(() => {
    if (
      isDemoTrading &&
      currentPathName !== "" &&
      !currentPathName.includes("/competition/d-cryptonary")
    ) {
      if (!isLoading && !hasValidated) {
        getIfHasCompetence();
      }
    } else {
      setHasCompetence(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDemoTrading, currentPathName, hasValidated, isLoading]);

  useEffect(() => {
    setMounted(true);
  }, []);

  return {
    hasCompetence,
    mounted
  };
};

export default useKolActivityCheck;
